import moment from 'moment-timezone';
import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { getCustomerDashboardConfig } from 'selectors/dashboard';
import { getNavParams } from 'selectors/nav';
import { getStartDate } from 'selectors/analytics';
import { useSelector } from 'store';
import { DefaultWidgetComponentProps } from 'types/dashboard';
import { TIME_RANGE_FIELD, useTimeRange } from 'utils/timeRanges';
import { OPTIONS } from '../Filters/TimeRangeFilterRedesign';

type RouterParams = {
  activeUuid?: string;
};

const formatDate = (date: string | Date | null | undefined, timezone?: string): string | null => {
  if (!date || !timezone) return null;

  const formatted = moment(date).tz(timezone).format('MM/DD/YYYY');

  return new Date(formatted).getTime() > 0 ? formatted : null;
};

const StaticDateRange: React.FC<DefaultWidgetComponentProps> = ({ subtitle }) => {
  const { activeUuid } = useParams<RouterParams>();

  const dashboardConfig = useSelector((state) =>
    getCustomerDashboardConfig(state, activeUuid || '')
  );

  const range = useTimeRange();
  const timeRange = useSelector((state) => getNavParams(state)[TIME_RANGE_FIELD] || '');
  const startDate = useSelector(getStartDate);

  const timezone = dashboardConfig?.primary_timezone;

  const createdAfter = useMemo(
    () => formatDate(range.created_after, timezone) || formatDate(startDate, timezone),
    [range.created_after, startDate, timezone]
  );

  const createdBefore = useMemo(
    () => formatDate(range.created_before, timezone),
    [range.created_before, timezone]
  );

  const currentRangeLabel = useMemo(
    () =>
      [...OPTIONS, { label: 'Past 6 Months', value: '-6months' }].find(
        ({ value }) => value === timeRange
      )?.label || 'Date Range',
    [timeRange]
  );

  return (
    <div className="flex flex-col">
      <div className="flex items-center mt-4">
        <h2 className="font-bold text-base mr-1">{currentRangeLabel}</h2>
        <div className="text-base">
          {createdAfter}
          {createdAfter && createdBefore ? ' - ' : null}
          {createdBefore}
        </div>
      </div>
      {subtitle && <div className="mt-1">{subtitle}</div>}
    </div>
  );
};

export default StaticDateRange;
